import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import DocumentsCircleIcon from '@/svg-icons/documents-circle';

const ViewResourcesSection = ({ resources }) => {
  const croqui = resources?.[0] || null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <DocumentsCircleIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="resources" />
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="font-bold">Croqui</div>
        <div className="flex flex-wrap gap-[1vw] mt-[0.5vw]">
          {!!croqui && (
            <div className="border border-[#DEDEDE] p-1">
              <img 
                key={croqui.uri} 
                src={croqui.uri} 
                alt="croqui" 
                className="h-[calc(80px+5vw)] object-contain" 
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ViewResourcesSection.propTypes = {
  resources: PropTypes.array,
};

ViewResourcesSection.defaultProps = {
  resources: [],
};

export default ViewResourcesSection;
